<template>
  <div class="uk-panel-box">
    <div class="uk-margin" uk-slider="center: true">
      <img data-src="/static/ic.png" width="900" height="600" alt="" uk-img>
    </div>
    <div class="uk-container">
      <div class="uk-form uk-inline uk-width-1-1 uk-height-small">
        <button v-on:click="mlogin" class="uk-button uk-button-secondary uk-button-large uk-position-bottom-right">携帯電話登録がない方</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IcReader',
  methods: {
    mlogin () {
      this.$router.replace('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/IcReader.vue